import * as yup from 'yup';

export interface PickupPointDetailsContactFormValues {
  metro: string;
  metroIconColor: string;
  phoneNumber: string;
  email: string;
}

export const pickupPointDetailsContactSchema = yup.object({
  metro: yup.string().defined(),
  metroIconColor: yup.string().defined(),
  phoneNumber: yup
    .string()
    .required('Укажите номер телефона')
    .test(
      'ru-mobile',
      'Введите полный номер в формате +7 (XXX) XXX-XX-XX',
      (value) => /^7[0-9]{10}$/.test((value ?? '').replace(/\D/g, '')),
    )
    .test(
      'ru-mobile-second-digit',
      'Некорректный номер',
      (value) => {
        const digits = (value ?? '').replace(/\D/g, '');
        return digits.length < 2 || digits[1] === '9';
      },
    ),
  email: yup.string().trim().required('Укажите email').email('Введите корректный email'),
}) as yup.ObjectSchema<PickupPointDetailsContactFormValues>;
